import toast from 'react-hot-toast';

const defaultErrorMessage = 'Đã có lỗi xảy ra, vui lòng thử lại sau';
const defaultSuccessMessage = 'Thành công';

/**
 * Extract human readable error message từ axios error object / NestJS response.
 * Ưu tiên đọc: e.response.data.message (string hoặc array[0]) → e.response.data.error
 *              → e.message → string e → fallback.
 * Pattern chính xác với ví dụ ảnh user gửi: {statusCode:400, message:"Tài khoản đang..."}.
 */
export function extractErrorMessage(e: any, fallback = defaultErrorMessage): string {
  if (!e) return fallback;
  const data = e?.response?.data;
  if (data) {
    if (typeof data.message === 'string' && data.message.trim()) return data.message.trim();
    if (Array.isArray(data.message) && data.message.length > 0) {
      const first = data.message[0];
      if (typeof first === 'string' && first.trim()) return first.trim();
    }
    if (typeof data.error === 'string' && data.error.trim()) return data.error.trim();
  }
  if (typeof e.message === 'string' && e.message.trim()) return e.message.trim();
  if (typeof e === 'string' && e.trim()) return e.trim();
  return fallback;
}

export async function showError(e: any, options = { duration: 3000 }) {
  const error = await e;
  toast.error(extractErrorMessage(error), options);
}

export function showSuccess(text = defaultSuccessMessage, options = { duration: 3000 }) {
  toast.success(text, options);
}

export async function copyToClipboard(str: string) {
  await navigator.clipboard.writeText(str);
  toast.success('Sao chép thành công');
}

/** Đọc accessToken từ query hoặc hash (#accessToken=...). */
export function readAccessTokenFromLocation(): string | null {
  if (typeof window === 'undefined') return null;
  const fromSearch = new URLSearchParams(window.location.search).get('accessToken');
  if (fromSearch) return fromSearch;
  const hash = window.location.hash.replace(/^#/, '');
  if (!hash) return null;
  return new URLSearchParams(hash).get('accessToken');
}

/** Game truyền token qua URL — không được auto guest / ghi đè session. */
export function hasUrlAccessToken(): boolean {
  return Boolean(readAccessTokenFromLocation());
}

/** True when page was opened with full game payment query params (skip-login H5 flow). */
export function isStandalonePaymentEntry(search = window.location.search): boolean {
  const params = new URLSearchParams(search);
  const required = ['productCode', 'accessToken', 'charId', 'googleProductId', 'price'];
  return required.every((key) => Boolean(params.get(key)));
}

export function buildUrl(baseUrl: string, params?: { [key: string]: any }) {
  if (!params) {
    return baseUrl;
  }

  const queryString = Object.keys(params)
    .map((k) => {
      if (Array.isArray(params[k])) {
        return params[k].map((param) => `${encodeURIComponent(k)}=${encodeURIComponent(param)}`)
          .join('&');
      }
      return `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`;
    })
    .join('&');
  return `${baseUrl}?${encodeURI(queryString)}`;
}